import { BlogConfig } from "./BlogConfig";
import { ClientsConfig } from "./ClientsConfig";

export const Config = {
    canonicalDomain : 'https://keperin.com',
    /* instagram : {
        graphUrl : "https://graph.facebook.com/v17.0",
        igAccountId : "17841460731967943",
        clientId : "162994690085119"
    }, */
    keywords : [
        'Desarrollo de aplicaciones empresariales',
        'Desarrollo web',
        'Creación de tiendas online',
        'Mejora de la presencia online',
        'Webs a medida',
        'Necesito una web',
        'Necesito sofware a medida'
    ],
    contact : {
        action : 'https://keperin.com/api/send',
        info : {
            email : {
                value : 'hello@keperin.com',
                link : 'mailto:hello@keperin.com'
            },
            phone : {
                value : '+34 618 558 689',
                link : 'https://wa.me/+34618558689'
            },
            location : 'A Coruña, España'
        }
    },
    footer : {
        copyright : '© 2023 keperin.com',
        rrss : {
          instagram : 'https://ig.me/m/keperin_',
          whatsapp : 'https://wa.me/+34618558689',
          linkedin : 'https://linkedin.com/company/keperin',
        },
        made_with : {
            link_disabled : true
        }
    },
    blog : BlogConfig,
    clients: ClientsConfig
}